import React from "react";

function VenueCalendarDashFilters({ label, onNavigate, children }) {
  const navigate = action => {
    onNavigate(action);
  };

  return (
    <>
      <div className="rbc-toolbar">
        <span className="rbc-btn-group">
          <button type="button" onClick={() => navigate("PREV")}>
            Prev
          </button>
          <button type="button" onClick={() => navigate("TODAY")}>
            Today
          </button>
          <button type="button" onClick={() => navigate("NEXT")}>
            Next
          </button>
        </span>
        <span className="rbc-toolbar-label">{label}</span>
      </div>
      <div className="mb-4 w-full" style={{ zIndex: 998 }}>
        <div className="flex flex-wrap items-end">
          {children}
        </div>
      </div>
    </>
  );
}

export default VenueCalendarDashFilters;
